import { AppContext } from "@Context/common/general/context";
import { useCallback, useContext } from "react";
import { Navigate } from "react-router-dom";
import { defineNotificationModule, INotificationResolverProps } from "../notification-service.types";
import { useAccountInfoResolved } from "../shared/use-account-info-resolved";
import { useNotificationCandidate } from "../use-notification-candidate";

const id = "EMAIL_VERIFICATION_REROUTE";

const EmailVerificationRerouteNotificationResolver = ({ priority }: INotificationResolverProps) => {
  const { state } = useContext(AppContext);
  const accountInfoResolved = useAccountInfoResolved(state.user.authenticated);
  const isActive = state.user.emailVerified === false && accountInfoResolved && state.user.authenticated && !state.device.isUnityEmbedded;

  const render = useCallback(() => <Navigate to="/account-verification" />, []);

  useNotificationCandidate({
    id,
    priority,
    isActive,
    render,
  });

  return null;
};

export const emailVerificationRerouteNotification = defineNotificationModule({
  id,
  Resolver: EmailVerificationRerouteNotificationResolver,
});
